import {
    CHECK_CLAIM_SUCCESS, GET_BUSINESSES_SUCCESS,
    GET_CLAIMS_SUCCESS,
    GET_EDITS_SUCCESS,
    GET_EVENTS_BY_ORGANIZATION_SUCCESS,
    GET_FOLLOWS_SUCCESS,
    GET_ORG_CATEGORIES_SUCCESS,
    GET_ORG_SOCIALS_SUCCESS,
    GET_ORGANIZATION_ADMINS_SUCCESS,
    GET_ORGANIZATION_BY_ID_SUCCESS,
    GET_ORGANIZATION_SUCCESS,
    GET_SUGGEST_INFO_SUCCESS,
    REMOVE_ORG_BY_ID,
    REMOVE_ORGANIZATION_BY_ID,
    REMOVE_SUGGEST_INFO,
} from './organizations.types';

const initialState = {
    organizations: [],
    businesses: [],
    organizationsById: null,
    hasClaim: false,
    claims: [],
    edits: [],
    orgEvents: [],
    suggestOrg: [],
    orgCategories: [],
    myFollows: [],
    orgSocials: null,
    orgAdmins: [],
};

export const organizationsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ORGANIZATION_SUCCESS:
            return {
                ...state,
                organizations: action.payload,
            };

        case GET_BUSINESSES_SUCCESS:
            return {
                ...state,
                businesses: action.payload,
            };

        case CHECK_CLAIM_SUCCESS:
            return {
                ...state,
                hasClaim: action.payload,
            };

        case GET_ORGANIZATION_BY_ID_SUCCESS:
            return {
                ...state,
                organizationsById: action.payload,
            };

        case REMOVE_ORGANIZATION_BY_ID:
            return {
                ...state,
                organizationsById: [],
            };

        /**Claims types */
        case GET_CLAIMS_SUCCESS:
            return {
                ...state,
                claims: action.payload,
            };

        /**Edits types */
        case GET_EDITS_SUCCESS:
            return {
                ...state,
                edits: action.payload,
            };

        /**Events */
        case GET_EVENTS_BY_ORGANIZATION_SUCCESS:
            return {
                ...state,
                orgEvents: action.payload,
            };

        /**Suggest */
        case GET_SUGGEST_INFO_SUCCESS:
            return {
                ...state,
                suggestOrg: action.payload,
            };

        case REMOVE_ORG_BY_ID:
            return {
                ...state,
                organizationsById: [],
            };

        case REMOVE_SUGGEST_INFO:
            return {
                ...state,
                organizationsById: [],
            };

        /**Categories */
        case GET_ORG_CATEGORIES_SUCCESS:
            return {
                ...state,
                orgCategories: action.payload,
            };

        /**Follows */
        case GET_FOLLOWS_SUCCESS:
            return {
                ...state,
                myFollows: action.payload,
            };

        case GET_ORG_SOCIALS_SUCCESS:
            return {
                ...state,
                orgSocials: action.payload,
            };

        case GET_ORGANIZATION_ADMINS_SUCCESS:
            return {
                ...state,
                orgAdmins: action.payload,
            };

        default:
            return state;
    }
};
